import { Center } from "@chakra-ui/react";
import Header from "components/Header";
import Layout from "components/Layout";
import NotFoundMessage from "components/NotFoundMessage";
import WalletErrors from "components/WalletErrors";
import { fancyBearsTokensAmount } from "config";
import useAssets from "hooks/useAssets";
import BearsListPage from "pages/BearsListPage";
import StoreBearPage from "pages/StoreBearPage";
import WardrobeBearPage from "pages/WardrobeBearPage";
import { Fragment } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { generateRandomInteger } from "utils/numberUtils";

const bearRoutes = [
  {
    path: "/store",
    component: StoreBearPage,
  },
  {
    path: "/wardrobe",
    component: WardrobeBearPage,
  },
];

const getRandomBear = () => generateRandomInteger(1, fancyBearsTokensAmount);

const ConnectedPage = () => {
  const { fancyBearsInWallet } = useAssets();

  return (
    <Layout>
      <Header />

      <Routes>
        <Route path="/" element={<Navigate to="/bears" replace />} />

        <Route path="/bears" element={<BearsListPage />} />

        {bearRoutes.map(({ path, component: Component }) => (
          <Fragment key={path}>
            <Route
              path={path}
              element={
                <Navigate
                  to={`${path}/${fancyBearsInWallet?.[0] || getRandomBear()}`}
                  replace
                />
              }
            />

            <Route path={`${path}/:tokenId`} element={<Component />} />
          </Fragment>
        ))}

        <Route
          path="*"
          element={
            <Center pt="12" pb="16">
              <NotFoundMessage />
            </Center>
          }
        />
      </Routes>

      <WalletErrors />
    </Layout>
  );
};

export default ConnectedPage;
